import React from 'react';
import PropTypes from 'prop-types';
import './loader3.scss';

const Loader = ({ size = 32, color = '#333', style }) => {
	const ratio = size / 64;
	const shift = -(64 - size) / 2;
	return <div className="loader" style={{ ...style, width: size, height: size }}>
		<div className="lds-roller" style={{ left: shift, top: shift, transform: `scale(${ratio}, ${ratio})` }}>
			{/*<div/><div/><div/><div/><div/><div/><div/><div/>*/}
			{[...new Array(8)].map((v, i) => <div key={i}><span style={{ background: color }} /></div>)}
		</div>
	</div>;
};

Loader.propTypes = {
	size: PropTypes.number, // размер в пикселях
	color: PropTypes.string, // цвет
	style: PropTypes.object, // дополнительные стили
};

export default Loader;
